import React, {useState} from 'react';

import Typography from '@mui/material/Typography';


function FundingInvestors(props) {
    const [investorsExpanded, setInvestorsExpanded] = useState(false);

    const handleExpandClick = () => {
        setInvestorsExpanded(!investorsExpanded)
    };

    const handleInvestorClick = (investor) => {
        if (investor.url) {
            window.open("//"+investor.url, "_blank");
        }
    };

    if (!props.investors.length) {
        return <div/>
    }

    let investors = investorsExpanded ? props.investors : props.investors.slice(0, 2);

    let suffixText = "";
    if (!investorsExpanded && props.investors.length > 2) {
        suffixText = "[" + (props.investors.length - 2) + " more]";
    } else if (investorsExpanded) {
        suffixText = "[show less]";
    }

    return (
        <div>
            <div
                style={{display: "flex", flexDirection: "row", justifyContent: "right", cursor: "pointer", flexWrap: "wrap", color:"rgb(0, 102, 153)"}}
            >
                {investors.map((investor, index) => (
                    <Typography
                        sx={{marginRight: "6px"}}
                        variant={'subtitle2'}
                        onClick={ () => {handleInvestorClick(investor)} }
                    >
                        {investor.name + (index === investors.length-1 ? "" : ", ")}
                    </Typography>
                ))}

                <Typography
                    sx={{marginRight: "6px", fontSize: "10px"}}
                    variant={'subtitle1'}
                    onClick={handleExpandClick}
                >
                    {suffixText}
                </Typography>

            </div>
        </div>
    )

}

export default FundingInvestors;